import { MainLayout } from 'components/Layout/MainLayout/MainLayout';
import { FunctionComponent } from 'react';

import { SubscriptionRequestForm } from './SubscriptionRequestForm/SubscriptionRequestForm';
import { useSubscriptionRequestPageTitleIntl } from './SubscriptionRequestPage.hook';

export const SubscriptionRequestPage: FunctionComponent = () => {
  const title = useSubscriptionRequestPageTitleIntl();

  return (
    <MainLayout withBrand={true} title={title}>
      <SubscriptionRequestForm />
    </MainLayout>
  );
};
